import { Button, Grid, IconButton, Typography } from "@mui/material";
import { Box } from "@mui/system";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';


export const FooterDet = () => {
    return (
        <Box className="no-overflow" id="contact" sx={{ width: '100%', bgcolor: "#282A3A", maxHeight: "25vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", p: { xs: "2rem",md:"5rem", lg: "5rem" }, textAlign: "center" }}>
            <Grid className="no-overflow" container spacing={2} maxHeight="75vh" minHeight="25vh" color="white" sx={{ width: { xs: "100%",md:"50%", lg: "50%" }, p:{xs:"0rem",md:"1rem",lg:"1rem"}  }} m="auto">
                <Grid className="no-overflow" item xs={6} textAlign="left" width="100%" m="auto">
                    <Typography className="no-overflow" sx={{
                        display: { xs: "flex", md:"flex",lg: 'flex' },
                        fontFamily: 'Molin',
                        fontSize: { xs: "0.5rem", md:"0.6rem",lg: "1.25rem" },
                        // fontWeight: 700,
                        color: '#C0C0C0',
                        textDecoration: 'none',
                        textAlign: { xs: "center", md:"left",lg: "left" },
                        textTransform: "capitalize",
                    }} >Interested in
                        <Typography className="no-overflow" sx={{
                            display: { xs: "flex", md:"flex",lg: 'flex' },
                            fontFamily: 'Molin',
                            fontSize: { xs: "0.5rem", md:"0.6rem",lg: "1.25rem" },
                            // fontWeight: 700,
                            color: '#C0C0C0',
                            textDecoration: 'none',
                            textAlign: { xs: "center", md:"left",lg: "left" },
                            textTransform: "capitalize",
                        }} >&nbsp;</Typography>
                        <Typography className="no-overflow" sx={{
                            display: { xs: "flex", md:"flex",lg: 'flex' },
                            fontFamily: 'Molin',
                            fontSize: { xs: "0.5rem", md:"0.6rem",lg: "1.25rem" },
                            // fontWeight: 700,
                            color: '#ECBC55',
                            textDecoration: 'none',
                            textAlign: { xs: "center", md:"left",lg: "left" },
                            textTransform: "capitalize",
                        }} >Talking?</Typography>
                    </Typography>
                </Grid>
                <Grid item className="no-overflow" xs={6} textAlign="left" width="100%" m="auto">
                    <Typography sx={{
                        display: { xs: "flex", md:"flex",lg: 'flex' },
                        fontFamily: 'Molin',
                        fontSize: { xs: "0.5rem", md:"0.6rem",lg: "1.25rem" },
                        // fontWeight: 700,
                        color: '#C0C0C0',
                        textDecoration: 'none',
                        textAlign: { xs: "center", md:"left",lg: "left" },
                        textTransform: "capitalize",
                    }} >You can find
                        <Typography sx={{
                            display: { xs: "flex", md:"flex",lg: 'flex' },
                            fontFamily: 'Molin',
                            fontSize: { xs: "0.5rem", md:"0.6rem",lg: "1.25rem" },
                            // fontWeight: 700,
                            color: '#C0C0C0',
                            textDecoration: 'none',
                            textAlign: { xs: "center", md:"left",lg: "left" },
                            textTransform: "capitalize",
                        }} >&nbsp;</Typography>
                        <Typography sx={{
                            display: { xs: "flex", md:"flex",lg: 'flex' },
                            fontFamily: 'Molin',
                            fontSize: { xs: "0.5rem", md:"0.6rem",lg: "1.25rem" },
                            // fontWeight: 700,
                            color: '#ECBC55',
                            textDecoration: 'none',
                            textAlign: { xs: "center", md:"left",lg: "left" },
                            textTransform: "capitalize",
                        }} >me</Typography>
                        <Typography sx={{
                           display: { xs: "flex", md:"flex",lg: 'flex' },
                            fontFamily: 'Molin',
                            fontSize: { xs: "0.5rem", md:"0.6rem",lg: "1.25rem" },
                            // fontWeight: 700,
                            color: '#C0C0C0',
                            textDecoration: 'none',
                            textAlign: { xs: "center", md:"left",lg: "left" },
                            textTransform: "capitalize",
                        }} >&nbsp;</Typography>
                        <Typography sx={{
                            display: { xs: "flex", md:"flex",lg: 'flex' },
                            fontFamily: 'Molin',
                            fontSize: { xs: "0.5rem", md:"0.6rem",lg: "1.25rem" },
                            // fontWeight: 700,
                            color: '#C0C0C0',
                            textDecoration: 'none',
                            textAlign: { xs: "center", md:"left",lg: "left" },
                            textTransform: "capitalize",
                        }} >on:</Typography>
                    </Typography>
                </Grid>
                <Grid item className="no-overflow" xs={6} textAlign="left" width="100%">
                    <Button variant="outlined" href='/contact'
                        sx={{
                            fontFamily: "Title", letterSpacing: '.2rem', alignItems: { xs: "center", md:"flex-start" ,lg: "flex-start" }, fontSize: { xs: 10,md:12 , lg: 15 },
                            textAlign: { sx: "center",md:"left" ,lg: "left" }, alignSelf: { xs: "center",md:"flex-start" , lg: "flex-start" }, color: "#ECBC55", padding: "0.5rem", width: { xs: "7rem",md:"8rem" , lg: "10rem" }, borderColor: "#808080", borderRadius: 2,
                            ":hover": { backgroundColor: "#FDDF9E", color: "#1D1F2A", }
                        }} > Contact Me</Button>
                </Grid>
                <Grid item xs={2} textAlign="left" width="100%">
                    <IconButton href="https://github.com/Innomer" sx={{
                        color: "#ECBC55", padding: "0.5rem", borderColor: "#808080", borderRadius: 2,
                        ":hover": { backgroundColor: "#FDDF9E", color: "#1D1F2A", }
                    }}>
                        <GitHubIcon sx={{ fontSize: { xs: "smaller",md:"larger" , lg: "larger" } }} />
                    </IconButton>
                </Grid>
                <Grid item xs={2} textAlign="left" width="100%">
                    <IconButton href="https://www.linkedin.com/in/innomer/" sx={{
                        color: "#ECBC55", padding: "0.5rem", borderColor: "#808080", borderRadius: 2,
                        ":hover": { backgroundColor: "#FDDF9E", color: "#1D1F2A", }
                    }}>
                        <LinkedInIcon sx={{ fontSize: { xs: "smaller",md:"larger" , lg: "larger" } }} />
                    </IconButton>
                </Grid>
                <Grid item xs={2} textAlign="left" width="100%">
                    <IconButton href="https://www.instagram.com/inn0m3r/" sx={{
                        color: "#ECBC55", padding: "0.5rem", borderColor: "#808080", borderRadius: 2,
                        ":hover": { backgroundColor: "#FDDF9E", color: "#1D1F2A", }
                    }}>
                        <InstagramIcon sx={{ fontSize: { xs: "smaller",md:"larger" , lg: "larger" } }} />
                    </IconButton>
                </Grid>
                <Box sx={{
                    display: {xs:"flex" ,md:"flex" ,lg: 'flex' },
                    fontFamily: 'Title',
                    fontSize: {xs:"0.5rem",md:"0.5rem" ,lg:"0.75rem"},
                    // fontWeight: 700,
                    color: '#C0C0C0',
                    textDecoration: 'none',
                    textAlign: "center",
                    justifyContent: "center",
                    textTransform: "capitalize",
                    width: {xs:"100%",md:"50%" ,lg:"50%"},
                    m: "auto",
                    ml: {xs:"auto",md:"auto" ,lg:"auto"}
                }} >Copyright © 2022 Mann Bhanushali. All rights reserved.
                </Box>
            </Grid>
        </Box >
    );
}